export default __webpack_public_path__ + "static/media/2408481502.c8965af7.png";